import { asce_710, isASCE722 } from "__common/constants/buildingCodes";
import { isRM10, isRM10Evolution, isRM5, isRMDT, isRMGridFlex, isRMIFIProduct, isRmGridflex10D, isRmGridflex5Rwdi } from "__common/constants/products";
import { AttachmentTypeShearIFIMaxLimit, AttachmentTypeShearRM10MaxLimit, AttachmentTypeShearRM10MaxLimitKg, AttachmentTypeShearRM5MaxLimit } from "../../fields/shearAllowable";
import { SOIL_CLASS } from "../../fields/soilClass";
import { RoofExposureOption } from "../../fields/types/roofExposure";
import { windExposureOption } from "../../fields/types/windExposure";
import { AttachmentTypeUpliftIFIMaxLimit, AttachmentTypeUpliftRM10MaxLimit, AttachmentTypeUpliftRM10MaxLimitKg, AttachmentTypeUpliftRM5MaxLimit } from "../../fields/upliftAllowable";
import { calculateKe, calculateKz, get_numerical_coefficient, get_design_life_factor, calculateFlatRoofSnowLoad } from "../coefficients";
import { isCanadianZipcode } from "../validation";
import store from "__common/store";
import { AttachmentType } from "../../fields/attachmentType";
import { uAnchorImprovements } from "__common/utils/versionCompare/versionCompare";
import { MAX_BLOCK_COUNTS, interiorBayCapacity, isHalfBlockAllowed, minBlockCount, rm5MaxBlockCount, rmGridflex10MaxBlockNorthCornerCount, rmGridflex10MaxBlockCount, rmGridflex5dMaxBlockCount } from "../constants";
import { AttachmentOptimization } from "../../fields/attachmentOptimizationCriteria";
import { state } from '__common/store';
import { flat } from "__common/constants/buildingTypes";

export default (product) => {
  const { userPreferences: { default_project_mode } } = state();
  
  const default_MRI = isCanadianZipcode(store.getState().projectConfiguration.projectEnvConfig.zipCode) || isRMGridFlex(product) || isRmGridflex10D(product) || isRmGridflex5Rwdi(product) ? 50 : 25;
  const DEFAULT_VALUES = {
    elevation: 5499,
    wind_speed: 115,
    wind_exposure: 'B',
    building_code: asce_710.value,
    attachment_optimization_criteria: 2,
    is_half_block_allowed: false,
    blocks_orientation : 0,
    domestic_content : 0,
  }
  const DEFAULT_THERMAL_FACTOR = isASCE722(DEFAULT_VALUES.building_code) ? 1.2 : 1;
  const DEFAULT_FLAT_ROOF_SNOW_LOAD = calculateFlatRoofSnowLoad(
    5, DEFAULT_THERMAL_FACTOR, DEFAULT_VALUES.wind_exposure, RoofExposureOption.partiallyExposed.value, 2, DEFAULT_VALUES.building_code,
  );
  const allRms = {
    zipcode: '',
    client_name: '',
    building_code: DEFAULT_VALUES.building_code,
    wind_speed: 115,
    snow_load: 5,
    seismic_ss: 0.46,
    elevation: 5499,
    mean_recurrence_interval: default_MRI,
    block_weight: 32,
    wind_exposure: 'B',
    dead_load_factor_modification: 0.6,
    risk_category: 2,
    input_unit: 1,
    building_type: flat.value,
    ...(isRMIFIProduct(product) || isRmGridflex10D(product) || isRmGridflex5Rwdi(product) ? {
      allow_manual_attachments:0,
      // parapet_height_input: 5,
      seismic_s1: 0,
      deflectors: isRmGridflex10D(product) || isRmGridflex5Rwdi(product) ? 1 : 0,
      soil_class: 4,
      psf_control: isRmGridflex10D(product) || isRmGridflex5Rwdi(product) ? 2 : 1,
      topographical_factor_kzt: 1,
      tilt: isRmGridflex10D(product)?10:5,
      central_rails_count: 0,
      allow_secondary_ballast_tray: 0,
    } : {}
    ),
    ...(isRM5(product) ? {
      anchor_type: 1,
      deflectors: 1,
      module_type: 2,
      allow_manual_attachments: 0
    } : {}
    ),
    ...((isRMIFIProduct(product) || isRmGridflex10D(product) || isRmGridflex5Rwdi(product) || isRM10(product) || isRM10Evolution(product) || isRM5(product)) ? {
      setback_distance: 3,
      allow_mechanical_attachments: 1,
      attachment_optimization_criteria: DEFAULT_VALUES.attachment_optimization_criteria,
      attachment_type: (isRM10Evolution(product)||isRM5(product)||isRMGridFlex(product) ||isRmGridflex10D(product) ||isRmGridflex5Rwdi(product)) ? 
        (uAnchorImprovements(store.getState().projectConfiguration.projectEnvConfig.projectVersion) ? 
        AttachmentType.U_ANCHOR_U2400 : AttachmentType.UNIRAC_FLASHLOC_RM) : AttachmentType.UNIRAC_FLASHLOC_RM,
      is_half_block_allowed: DEFAULT_VALUES.is_half_block_allowed,
      half_block_weight: 16,
      seismic_s1: 0,
      tornado_speed: 0,
      building_height_greater_than_6_storey: 0,
      ...(isRM10(product) || isRM10Evolution(product) || isRM5(product) || isRmGridflex10D(product) ? {
        psf_control: 2,
        nbcc_wind_pressure: 0.30,
        nbcc_category: 2,
        nbcc_roughness: 0,
        rain_load: 0.1,
        ...(isCanadianZipcode(store.getState().projectConfiguration.projectEnvConfig.zipCode)) ? {
          uplift_allowable: AttachmentTypeUpliftRM10MaxLimitKg.UNIRAC_FLASHLOC_RM,
          shear_allowable: AttachmentTypeShearRM10MaxLimitKg.UNIRAC_FLASHLOC_RM,
        } :
          {
            uplift_allowable: AttachmentTypeUpliftRM10MaxLimit.UNIRAC_FLASHLOC_RM,
            shear_allowable: AttachmentTypeShearRM10MaxLimit.UNIRAC_FLASHLOC_RM
          }
      } : {
        uplift_allowable:  AttachmentTypeUpliftIFIMaxLimit.UNIRAC_FLASHLOC_RM,
        shear_allowable: AttachmentTypeShearIFIMaxLimit.UNIRAC_FLASHLOC_RM,
      })
    } : {}),
    ...(isRM10Evolution(product) || isRmGridflex10D(product) || isRmGridflex5Rwdi(product) ? {
      allow_north_bays: 1,
      seismic_sds: 0.01,
      seismic_sd1: 0.01,
    } : {}),
    ...(isRM10(product) || isRM10Evolution(product) || isRmGridflex10D(product) || isRmGridflex5Rwdi(product) || isRMGridFlex(product) || isRM5(product) ? {
      allow_manual_attachments: 0,
      soil_class: SOIL_CLASS.D,
      velocity_pressure_exposure_coefficient_kz: calculateKz(DEFAULT_VALUES.wind_exposure, 15, ''),
      ground_elevation_factor_ke: calculateKe(DEFAULT_VALUES.elevation),
      wind_directionality_factor_kd: 0.85,
      roof_exposure: RoofExposureOption.partiallyExposed.value,
      numberical_coefficient: get_numerical_coefficient(DEFAULT_VALUES.building_code, DEFAULT_VALUES.elevation),
      topographical_factor_kzt: 1,
      design_life_factor_fc: get_design_life_factor(default_MRI),
    } : {}),
    ...(isRM10Evolution(product) ? {
      max_block_count : MAX_BLOCK_COUNTS[product],
      min_block_count : minBlockCount(DEFAULT_VALUES.attachment_optimization_criteria === AttachmentOptimization.FULLY_ATTACHED, isHalfBlockAllowed(DEFAULT_VALUES.is_half_block_allowed), product),
      interior_bay_capacity : interiorBayCapacity(product, isHalfBlockAllowed(DEFAULT_VALUES.is_half_block_allowed)),
      use_default_flat_slope_roof_snow_load: 1,
      thermal_factor: DEFAULT_THERMAL_FACTOR,
      flat_roof_snow_load: DEFAULT_FLAT_ROOF_SNOW_LOAD,
    } : {}),
    ...((isRMIFIProduct(product) || isRmGridflex10D(product) || isRmGridflex5Rwdi(product) || isRM10(product) || isRM10Evolution(product) || isRMDT(product) || isRM5(product)) ? {
      limit_down_point_loads: 0,
    } : {}),
    ...(isRM5(product) ? {
     central_support: 0,
    //  soil_class: SOIL_CLASS.D_DEFAULT,
     uplift_allowable: AttachmentTypeUpliftRM5MaxLimit.UNIRAC_FLASHLOC_RM,
     shear_allowable: AttachmentTypeShearRM5MaxLimit.UNIRAC_FLASHLOC_RM,
     use_default_block_capacities : true,
     use_default_flat_slope_roof_snow_load: 1,
     thermal_factor: DEFAULT_THERMAL_FACTOR,
     flat_roof_snow_load: DEFAULT_FLAT_ROOF_SNOW_LOAD,
     max_block_count : rm5MaxBlockCount(isHalfBlockAllowed(DEFAULT_VALUES.is_half_block_allowed)),
     min_block_count : minBlockCount(DEFAULT_VALUES.attachment_optimization_criteria === AttachmentOptimization.FULLY_ATTACHED, isHalfBlockAllowed(DEFAULT_VALUES.is_half_block_allowed), product),
     } : {}),
    ...(isRMGridFlex(product) || isRmGridflex10D(product) || isRmGridflex5Rwdi(product) ? {
      mandatory_mid_support: 0,
      thermal_factor: isASCE722(DEFAULT_VALUES.building_code) ? 1.2 : 1,
      load_sharing_type: 'default',
      friction_factor: 0.5,
      fully_adhered: 1,
      seismic_ip: 1,
      snow_is: 1,
      wind_iw: 1,
      } : {}),
    ...(isRmGridflex10D(product) || isRmGridflex5Rwdi(product) ? {
      use_default_flat_slope_roof_snow_load: 1,
      flat_roof_snow_load: DEFAULT_FLAT_ROOF_SNOW_LOAD,
    } : {}),
    ...(isRmGridflex10D(product) || isRmGridflex5Rwdi(product)? {
      additional_rail: 1,
      blocks_orientation: DEFAULT_VALUES.blocks_orientation,
      roofPsfLimit: 3,
      is_ul3741_required: 0,
      use_friction: 0,
      use_default_block_capacities : true,
      use_default_max_block_north_corner: true,
      max_block_north_corner_count: rmGridflex10MaxBlockNorthCornerCount(isHalfBlockAllowed(DEFAULT_VALUES.is_half_block_allowed), store.getState().moduleSelector.modelData.height),
      max_block_count : isRmGridflex5Rwdi(product) ? rmGridflex5dMaxBlockCount(isHalfBlockAllowed(DEFAULT_VALUES.is_half_block_allowed), store.getState().moduleSelector.modelData.height) : rmGridflex10MaxBlockCount(isHalfBlockAllowed(DEFAULT_VALUES.is_half_block_allowed), store.getState().projectConfiguration.projectEnvConfig.blocks_orientation),
      min_block_count : minBlockCount(DEFAULT_VALUES.attachment_optimization_criteria === AttachmentOptimization.FULLY_ATTACHED, isHalfBlockAllowed(DEFAULT_VALUES.is_half_block_allowed), product),
    }: {}),
    ...(!(isRmGridflex10D(product) || isRmGridflex5Rwdi(product)) ? {
      tornado_speed: 0,
      seismic_sds: 0.01,
      seismic_sd1: 0.01,
    } : {}),
    ...(isRM10(product) || isRM10Evolution(product) ? {
      use_friction: 0,
      add_roof_pads_everywhere: 0,
    } : {}),
    ...(isRM5(product) ? {
      use_friction: 0,
    } : {}),
    ...(isRM5(product) || isRM10Evolution(product) ? {
      central_support_choice: 2,
      }:{}),
      ...(isRmGridflex10D(product) || isRmGridflex5Rwdi(product)? {
        domestic_content : DEFAULT_VALUES.domestic_content,
      }:{}),
      ...(isRM10Evolution(product) || isRM5(product) || isRMDT(product) ? {
        domestic_content : DEFAULT_VALUES.domestic_content,
      }:{}),
      is_test:default_project_mode
    };
  return allRms;
};
